import Observable from './observable';
export default function fromPromise(promise) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        promise.then(
        // tslint:disable-next-line:ter-prefer-arrow-callback
        function resolve(value) {
            observer.next(value);
            observer.complete();
        }, 
        // tslint:disable-next-line:ter-prefer-arrow-callback
        function reject(value) {
            observer.error(value);
        });
    });
}
//# sourceMappingURL=from-promise.js.map